import React, { useState } from "react";
import { useParams } from "react-router";
import { Heading, Loader, Popup } from "uikit/components";
import { BackLink } from "components";
import styles from "./RegionTrainingPlansPage.module.styl";
import RegionTrainingPlansView from "components/regionSummary/RegionTrainingPlansView/RegionTrainingPlansView";
import { useRegionTrainingPlans } from "hooks/trainingPlans/useRegionTrainingPlans";
import Pagination from "uikit/components/Pagination/Pagination";
import math from "lodash";
import { useContextPerson } from "hooks/persons";
import { Flags } from "utils";
import { Helmet } from "react-helmet-async";

export default function RegionTrainingPlansPage() {
    const pageSize = 20;

    const [payload, setPayload] = useState({ pageNumber: 1 });

    const { regionId } = useParams();
    const { flags, isLoading: isContextLoading } = useContextPerson();
    const { isLoading, data } = useRegionTrainingPlans(regionId, payload, {
        keepPreviousData: true,
    });

    const handlePageChange = (newPageNumber) => {
        setPayload((payload) => ({ ...payload, pageNumber: newPageNumber }));
    };

    if (isLoading || isContextLoading) {
        return (
            <Popup blockClickOnOverlay appearance="adaptive">
                <Loader position={"margin-auto"} text={"Подождите. Данные загружаются."} testName="loader-text" />
            </Popup>
        );
    }

    if (data) {
        return (
            <>
                <Helmet>
                    <meta
                        name="apple-mobile-web-app-title"
                        content={`Ведение планов тренировок: ${data.regionName}`}
                    />
                    <meta
                        name="application-name"
                        content={`Ведение планов тренировок: ${data.regionName}`}
                    />
                </Helmet>
                {!flags?.[Flags.HideDashboardBackButton] && (
                    <BackLink
                        to={`/region-summary/${regionId}`}
                        text={"Назад"}
                        name={"back_link"}
                        data-test-name="back-region-dashboard"
                    />
                )}
                <Heading size={"h1"} className={styles.heading} name="region-training-plans-header">
                    Ведение планов тренировок: {data.regionName}
                </Heading>
                <RegionTrainingPlansView
                    regionId={Number(regionId)}
                    schoolTrainingPlans={data.schoolTrainingPlans}
                />
                {data.count > pageSize && (
                    <Pagination
                        pageCount={math.ceil(data.count / pageSize)}
                        forcePage={payload.pageNumber}
                        onPageChange={handlePageChange}
                        className={styles.pagination}
                    />
                )}
            </>
        );
    }
}
